/**
 * 辅视图装饰器
 */
import {
  checkAmerican,
  transformTime
} from '../../../controller/util.js';
import {mergeModelData} from '../../../util/index.js';
import {checkFutures,getTime,getTimeStamp} from '../../../controller/util.js';
const model = {
  axisX: {
    Type: Array,
    Required: true,
    Default: () => ([])
  },
  footContextKey: {
    Type: Number,
    Required: true,
  }
};
const FootDectorator = BaseClass => class extends BaseClass {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcGrid() {
    const {width, height, top, left, isFullScreen} = this.state;
    const {size, fullSize} = this.option.FootContext;
    const {
      left: dleft,
      top: dtop,
      right: dright,
      bottom: dbottom
    } = !isFullScreen ? size : fullSize;
    const height1 = this.state.top
    const dtop1 = !isFullScreen?this.option.MainContext.size.top:this.option.MainContext.fullSize.top
    this.availArea = {
      left: left + width * dleft,
      top: top + height * dtop,
      right: left + width * (1 - dright),
      bottom: top + height * (1 - dbottom),
      width: width * (1 - dleft - dright),
      height: height * (1 - dtop - dbottom),
      height1: height1 * (1 - dtop1 - dbottom)
    };
  }
  _drawGrid() {
    const {height, top, left, right} = this.availArea;
    const dashAmount = 2; // 分割的空间
    const x1 = left;
    const x2 = right;
    const {dashColor, solidColor} = this.option.FootContext;
    if(this.option.FootContext.axisX==null){//实例2
      for (let i = 0; i < dashAmount; i++) {
        const axisY = top + (height / dashAmount) * i;
        const p1 = {x: x1, y: axisY};
        const p2 = {x: x2, y: axisY};
        if(i==1){
          // this._drawSolid(p1, p2, this.dpr * 0.8, solidColor);
          this._drawDash(p1, p2, this.dpr * 0.2, dashColor);
        }
        // this._drawSolid(p1, p2, this.dpr * 0.8, solidColor);
        // this._drawDash(p1, p2, this.dpr * 0.5, dashColor);
      }
    }
    const axisY = top + height;
    // 辅视图下边框
    this._drawSolid({x: x1, y: axisY}, {x: x2, y: axisY}, this.dpr * 0.8, solidColor);
  }
  _drawAxisX() {
    const {
      top,
      height,
      isFullScreen,
    } = this.state;
    const {axisX} = this.state.data;
    const {
      left,
      width,
      right,
      bottom
    } = this.availArea;
    const {dashColor, solidColor} = this.option.FootContext;
    // 分时的左右边框
    // this._drawSolid({x:0,y:0},{x:0,y:bottom}, this.dpr, solidColor, this.context);
    // this._drawSolid({x:right,y:0},{x:right,y:bottom}, this.dpr, solidColor, this.context);
    if (!this.option.FootContext.axisX) {
      // 指标分离时不需要展示坐标轴 此处做特殊处理
      return
    }
    const {code,singleAmount} = this.store.state;
    const {
      top: topRatio,
      sizeRatio,
      fontFamily,
      color
    } = !isFullScreen ? this.option.FootContext.axisX : this.option.FootContext.fullAxisX;
    const ctx = this.context;
    ctx.font = sizeRatio * this.state.baseSize * this.dpr + "px " + fontFamily;
    ctx.textBaseline = "top";
    ctx.fillStyle = color;
    const len = axisX.length;
    if (len === 1) {
      return;
    }
    const topY = top + height * topRatio;
    if (!checkFutures(code)) {
      const step = width / (len - 1);
      for (let i = 0; i < len; i++) {
        ctx.beginPath();
        let leftX = left + step * i;
        if (i === 0) {
          ctx.textAlign = "left";
        } else if (i === len - 1) {
          ctx.textAlign = "right";
        } else {
          ctx.textAlign = "center";
        }
        ctx.fillText(axisX[i], leftX, topY);
        this._drawDash({x:leftX,y:top}, {x:leftX,y:0}, this.dpr * 0.2, dashColor)
      }
      return
    }
    // 期货时间轴绘制：开收盘关键点+每隔一小时一个点，外盘为每两个小时
    let interval = 100
    if(checkFutures(code,'en')) {
      interval = 200
    }
    let validArr = []
    for (let j in axisX) {
      let now_axis = axisX[j]
      if (j==0) {
        validArr.push(now_axis)
        continue
      }
      let com = Number(axisX[j-1].split('/')[axisX[j-1].split('/').length-1].replace(':',''))
      let curr = Number(now_axis.split('/')[0].replace(':',''))
      curr < com && (curr += 2400)
      for (let k = com+interval;;k+=interval) {
        if (k < curr) {
          validArr.push(getTime(k))
        } else {
          validArr.push(now_axis)
          break
        }
      }      
    }
    const perLeft =  width / singleAmount
    let leftX = left;
    validArr.forEach((item,i) => {
      if (i === 0) {
        ctx.textAlign = "left"
      } else if (i === validArr.length - 1) {
        leftX = left + width
        ctx.textAlign = "right"
      } else {
        let last_left = leftX
        let now = Number(item.split('/')[0].replace(':',''))
        let last = Number(validArr[i-1].split('/')[validArr[i-1].split('/').length-1].replace(':',''))
        let last_text_wid = ctx.measureText(validArr[i-1]).width
        let now_text_wid = ctx.measureText(item).width
        now < last && (now+=2400)
        leftX += getTimeStamp(last,now)*perLeft
        if((last_text_wid+now_text_wid)/2 > (leftX-last_left)) {
          ctx.textAlign = "left";
        }else {
          ctx.textAlign = "center";
        }
        this._drawDash({x:leftX,y:top}, {x:leftX,y:0}, this.dpr * 0.2, dashColor)
      }
      ctx.fillText(item, leftX, topY);
    })   
  }
  _showCursor({x, index}) {
    const {len} = this.state.data;
    if(!len) {
      // 绘图长度为0时不显示十字线
      return
    }
    const ctx2 = this.curContext;
    const baseSize = this.state.baseSize;
    const {min_time, start, code} = this.state.data;
    const {height} = this.state
    const {left, top, right, bottom, width} = this.availArea;
    const {
      spaceX,
      spaceY,
      sizeRatio,
      fontFamily,
      color,
      backColor,
      radius,
      lineWidth
    } = this.option.FootContext.label;
    const top_ratio = this.option.FootContext.size.top
    const labelHeight = (2 * spaceY + sizeRatio * baseSize) * this.dpr*1.2;
    let topY = top-height*top_ratio;
    // 辅视图纵向十字线
    this._drawDash({x, y: top-20}, {x, y: bottom}, this.dpr/2 , backColor,5, 3,ctx2);
    if (!this.option.FootContext.axisX) {
      // 指标分离时不需要展示时间轴 此处做特殊处理
      return
    }
    /*** 绘制X轴标签 ***/
    ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
    ctx2.textAlign = 'center';
    ctx2.textBaseline = 'middle';
    const isAmerican = checkAmerican(code);
    const text = transformTime({timeStamp: min_time[index], code, isAmerican});
    const textWidth = ctx2.measureText(text).width;
    const labelWidth = textWidth + 2 * spaceX;
    let leftX = x - labelWidth / 2;
    if (leftX < left) {
      leftX = left;
    } else if (leftX + labelWidth > right) {
      leftX = right - labelWidth;
    }
    this._drawBoxRadius({
      left: leftX,
      top: topY,
      width: labelWidth,
      height: labelHeight,
      radius,
      strokeStyle: backColor,
      fillStyle: backColor
    });
    ctx2.fillStyle = color;
    ctx2.fillText(text, leftX + labelWidth / 2, topY + labelHeight / 2);
  }
  _hideCursor() {}
}
export default FootDectorator;
